
export default function LiveLoading() {
    return (
        <div className="wf-section">
            &nbsp;
        </div>
    );
}
